import React, { useState } from "react";
import { UnmountClosed } from "react-collapse";
import { DateHelper } from "../../../../../../react-core/Helpers/DateHelper";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { MonthChargeTypesDetailModel } from "../../../../../../Wrap/Models/Models/AdviserCharges/MonthChargeTypesDetailModel";
import { MonthChargeTypesValuationModel } from "../../../../../../Wrap/Models/Models/AdviserCharges/MonthChargeTypesValuationModel";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";

interface IExpandableTableChargesProps {
    data: MonthChargeTypesValuationModel[];
}

export const ExpandableTableCharges = (props: IExpandableTableChargesProps) => {
    if (!props.data) { return null; }
    if (props.data.length == 0) { return <Alert alertType={AlertType.Warning} message={"No results have been found for the entered criteria."} />; }
    return (
        <div className="panel pr-0 pl-0 pb-0 pt-0">
            <table className="table-expandable has-mainrow-modified">
                <thead>
                    <tr>
                        <th className="cell-left cell-20">Adviser name</th>
                        <th className="cell-right cell-15">Initial Adviser charge</th>
                        <th className="cell-right cell-15">Ongoing Adviser charge</th>
                        <th className="cell-right cell-18">Regular payment adviser charge</th>
                        <th className="cell-right cell-18">Drawdown Initial Adviser Charge</th>
                        <th className="cell-right cell-18">Ad hoc charge</th>
                        <th className="cell-right cell-18 pr-24">Total</th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.map((ele) => {
                        return <ExpandableTableChargesRow ele={ele} />;
                    })}
                </tbody>
            </table>
        </div>
    );
};

const ExpandableTableChargesRow = (props: { ele: MonthChargeTypesValuationModel }) => {
    const [expanded, setExpanded] = useState(false);
    return (
        <>
            <tr className="te-mainrow">
                <td colSpan={8}>
                    <button
                        className="te-expand-btn has-label"
                        aria-expanded={expanded}
                        onClick={() => setExpanded(!expanded)}
                    >
                        <span className="icon" aria-hidden={true} />
                        <span className="sr-only">Click to expand details for this row</span>
                        <span>{`${JsonDateParser.getMonthNameMapping(props.ele.MonthOfYear.Month)} ${props.ele.MonthOfYear.Year
                            }`}</span>
                    </button>
                </td>
            </tr>

            <tr className="te-subrow">
                <td colSpan={8}>
                    <UnmountClosed isOpened={expanded}>
                        <div className="te-subwrap">
                            <table className="data-table mb-0">
                                <thead className="sr-only">
                                    <tr>
                                        <th className="cell-left">Adviser name</th>
                                        <th className="cell-right">Initial Adviser charge</th>
                                        <th className="cell-right">Ongoing Adviser charge</th>
                                        <th className="cell-right">Regular payment adviser charge</th>
                                        <th className="cell-right">Drawdown Initial Adviser Charge</th>
                                        <th className="cell-right">Ad hoc charge</th>
                                        <th className="cell-right">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.ele.MonthChargeTypesDetails.map((row: MonthChargeTypesDetailModel) => (
                                        <tr>
                                            <td className="cell-left cell-10">{row.AdviserName}</td>
                                            <td className="cell-right cell-15">
                                                {MoneyDisplayHelper.getMoneyFormat(row.IAC)}
                                            </td>
                                            <td className="cell-right cell-15">
                                                {MoneyDisplayHelper.getMoneyFormat(row.OAC)}
                                            </td>
                                            <td className="cell-right cell-20">
                                                {MoneyDisplayHelper.getMoneyFormat(row.RIAC)}
                                            </td>
                                            <td className="cell-right cell-20">
                                                {MoneyDisplayHelper.getMoneyFormat(row.DIAC)}
                                            </td>
                                            <td className="cell-right cell-15">
                                                {MoneyDisplayHelper.getMoneyFormat(row.AAC)}
                                            </td>
                                            <td className="cell-right cell-8">
                                                {MoneyDisplayHelper.getMoneyFormat(row.Total)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>Total</td>
                                        <td className="cell-right">
                                            {MoneyDisplayHelper.getMoneyFormat(props.ele.Valuation.IACTotal)}
                                        </td>
                                        <td className="cell-right">
                                            {MoneyDisplayHelper.getMoneyFormat(props.ele.Valuation.OACTotal)}
                                        </td>
                                        <td className="cell-right">
                                            {MoneyDisplayHelper.getMoneyFormat(props.ele.Valuation.RIACTotal)}
                                        </td>
                                        <td className="cell-right">
                                            {MoneyDisplayHelper.getMoneyFormat(props.ele.Valuation.DIACTotal)}
                                        </td>
                                        <td className="cell-right">
                                            {MoneyDisplayHelper.getMoneyFormat(props.ele.Valuation.AACTotal)}
                                        </td>
                                        <td className="cell-right">
                                            {MoneyDisplayHelper.getMoneyFormat({
                                                Amount:
                                                    props.ele.Valuation.IACTotal.Amount +
                                                    props.ele.Valuation.OACTotal.Amount +
                                                    props.ele.Valuation.RIACTotal.Amount +
                                                    props.ele.Valuation.DIACTotal.Amount +
                                                    props.ele.Valuation.AACTotal.Amount,
                                                Currency: CurrencyCode.GBP,
                                            })}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </UnmountClosed>
                </td>
            </tr>
        </>
    );
};
